import React, { useCallback } from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { TableInputs } from "components/CardTable/TableInputs";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportUnitPerformanceFilters, getReportUnitPerformanceAction } from "redux/actions/Reports/reportUnitPerformance/reportUnitPerformanceActions";
import { useSearch } from "hooks/useSearch";

export const ReportUnitPerformanceView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(state => state.reportUnitPerformance);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault();
    if (!station?.id) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportUnitPerformanceAction({ startDate, endDate, station, isPdf }));
  }, [startDate, endDate, station]);

  return (
    <GlobalBox title="Reporte Rendimiento de Unidades" icon={<AssessmentIcon />}>
      <TableInputs
        reducer="reportUnitPerformance"
        dates
        stations
        maxDate={newDate()}
        dispatchAction={setReportUnitPerformanceFilters}
        submitAction={handleSubmit}
        submitSecond={(e) => handleSubmit(e, false)}
        submitButtonName="PDF"
        loading={isLoadingComp?.loadingUnitPerformance}
      />
      {isLoadingComp?.loadingUnitPerformance && (
        <LoadingComponent height="100%" />
      )}
    </GlobalBox>
  );
};
